import React from 'react'
import AdmPartyMaster from '../../components/AdminTabs/AdminPartyMaster/AdmPartyMaster'

const PartyMaster = () => {
  return (
    <div>
      <AdmPartyMaster/>
    </div>
  )
}

export default PartyMaster
